<template>
    <div>
        <app-wysiwyg
            label="Überschrift"
            :data-source="'tecpage.user.modules.' + moduleId + '.data.title'"
            textpicker-namespace="referenceswidget/title"
            required
            :maxlength="255"
            :slim="true"
        ></app-wysiwyg>

        <app-wysiwyg
            label="Unterüberschrift"
            :data-source="'tecpage.user.modules.' + moduleId + '.data.subtitle'"
            textpicker-namespace="referenceswidget/subtitle"
            required
            :maxlength="255"
            :slim="true"
        ></app-wysiwyg>

        <app-wysiwyg
            label="Text"
            :data-source="'tecpage.user.modules.' + moduleId + '.data.text'"
            textpicker-namespace="referenceswidget/text"
            :maxlength="1024"
        ></app-wysiwyg>

        <app-filepicker
            v-if="[3, 4].includes(getProp('tecpage.user.modules.' + moduleId + '.layout.type'))"
            label="Bild"
            :data-source="'tecpage.user.modules.' + moduleId + '.data.image'"
            accept=".jpg,.png,.gif"
            :show-focus="true"
            :show-transparency="false"
        ></app-filepicker>

        <!--
        <app-list
            :data-source="'deha.user.misc.references'"
            :data-preset="false"
            :data-name="'data.name'"
            :list-subpage="'References'"
            :allow-individual="true"
            :label="'Referenz'"
        ></app-list>
        -->

        <div class="field-wrap field-text field-text--small">
            <p v-html="$helpers.uiText('R074')"></p>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Text from '@/components/fields/simple/Text.vue';
import Wysiwyg from '@/components/fields/simple/Wysiwyg.vue';
import List from '@/components/fields/complex/List.vue';
import Filepicker from '@/components/fields/complex/Filepicker.vue';

export default {
    data() {
        return {};
    },
    methods: {},
    computed: {
        ...mapGetters(['getProp'])
    },
    mounted() {
        this.$emit('controlhead', {
            title: this.$helpers.uiText('R005'),
            help: this.$helpers.uiText('R078'),
            removeText: this.$helpers.uiText('R026'),
            showGlobal: false
        });
    },
    props: {
        moduleId: String
    },
    components: {
        'app-text': Text,
        'app-wysiwyg': Wysiwyg,
        'app-list': List,
        'app-filepicker': Filepicker
    }
};
</script>
